import {computed, observable, makeObservable} from "mobx";
import {ArrayUtils} from "../../utils/data/array/ArrayUtils";
import type {IModel, IModelData} from "./Model";

export interface IPortfolioGroupData extends IModelData {
	portfolioGroupID: string; //"f25f4914-6115-45fb-a000-aaaaaaaa0001"
	portfolios: string[]; //"f25f4914-6115-45fb-a000-aaaaaaaa0001"
	name: string;
	lastModifiedAt: string; //"2020-04-12T18:55:00.4361514+00:00"
	lastModifiedBy: string; //"f25f4914-6115-45fb-a000-aaaaaaaa0023"
}

export class PortfolioGroup implements IModel {
	public static readonly id = 1;

	private _data: IPortfolioGroupData;

	constructor(data: IPortfolioGroupData) {
		makeObservable<this, "_data">(this, {
			_data: observable,
			id: computed,
			name: computed,
			portfolioIds: computed,
			lastModifiedAt: computed,
			lastModifiedBy: computed,
			data: computed,
		});
		this._data = data;
	}

	public get id() {
		return this._data.portfolioGroupID;
	}

	public set name(value: string) {
		this._data.name = value;
	}

	public get name() {
		return this._data.name ?? "";
	}

	public addPortfolio(portfolioId: string) {
		ArrayUtils.addMutable(this._data.portfolios, portfolioId);
	}

	public removePortfolio(portfolioId: string) {
		ArrayUtils.removeMutable(this._data.portfolios, portfolioId);
	}

	public get portfolioIds() {
		return this._data.portfolios;
	}

	public get lastModifiedAt() {
		return this._data.lastModifiedAt;
	}

	public get lastModifiedBy() {
		return this._data.lastModifiedBy;
	}

	public get data() {
		return this._data;
	}
}
